import React from "react";
import "./Rewards.sass";

export default function Rewards() {
  return (
    <div className="reward">
      <div className="reward-bg-part-1"></div>
      <div className="engine-images">
        <div className="dream-machine">
          <img src="/images/engine23.png" alt="" />
        </div>
        <div className="frengine not-mobile">
          <img src="/images/FrENGINE2.png" alt="" />
        </div>
        <div className="degengine not-mobile">
          <img src="/images/degENGINE.png" alt="" />
        </div>
      </div>
      <div className="engine-names">
        <h2 className="dotted-border dream-dotted-mobile">DREAM MACHINE</h2>
        <h2 className="engine-operators not-mobile">=</h2>
        <h2 className="dotted-border not-mobile">frENGINE</h2>
        <h2 className="engine-operators not-mobile">+</h2>
        <h2 className="dotted-border not-mobile">degENGINE</h2>
      </div>
      <div className="reward-mystery">
        Unveil the Mystery <br className="mobile" /> out of the box with
        degENGINE
      </div>
      <div className="reward-degengine">
        <div className="reward-degengine-boxes">
          <h2 className="not-mobile">Machine Name : frENGINE</h2>
          <h2 className="reward-frengine-title">degENGINE</h2>
          <p>Work : Produce Goods to Sustain the FRENCONOMY</p>
          <p>Assets Required to run it : Tendies + NFTS</p>
          <div className="reward-degengine-vault">
            <img src="/images/vault.png" alt="vault" />
          </div>
          <div className="reward-degengine-box">
            <img src="/images/rewards-box.png" alt="box" />
          </div>
        </div>
        <div className="reward-degengine-options">
          <div className="reward-degengine-engine">
            <img src="/images/degenginegif.png" alt="degengine" />
          </div>
          <div className="reward-degengine-tendies">
            <img src="/images/tendies2.png" alt="tendies" />
            <p>TENDIES</p>
          </div>
          <div className="reward-degengine-nfts">
            <h4>Any 2</h4>
            <h3>FREN</h3>
            <h2>NFTs</h2>
          </div>
        </div>
      </div>

      <div className="reward-get ">
        <h2 className="not-mobile">REWARDS YOU CAN GET</h2>
        <div className="reward-get-options mobile">
          <div className="reward-get-options-images">
            <div className="reward-reactor">
              <img src="/images/arcreactor3.png" alt="reactor" />
              <h3>ARC REACTOR</h3>
            </div>
            <div className="reward-crystals">
              <img src="/images/crystals.png" alt="crystals" />
              <h3>CRYSTALS</h3>
            </div>
            <div className="reward-more-tendies">
              <img src="/images/more-tendies.png" alt="more tendies" />
              <h3>MORE TENDIES</h3>
            </div>
            <div className="reward-madrid-fren">
              <img src="/images/MadeinMadrid.png" alt="madrid fren" />
              <h3>SPECIAL MADE IN MADRID FREN</h3>
            </div>
            <div className="reward-tendies">
              <img src="/images/tendies.png" alt="tendies" />
              <h3>
                10% TENDIES BURN (EVERY MYSTERY HAS ITS DARK SIDE AS WELL)
              </h3>
            </div>
            <div className="reward-block">
              <img src="/images/block.png" alt="block" />
              <h3>GET A Block of Land at WADISHADES BAYO</h3>
              <a className="reward-learn" href="https://discord.gg/onlyfrens">
                LEARN MORE
              </a>
            </div>
          </div>
        </div>
        <div className="reward-get-options  not-mobile">
          <div className="reward-get-options-images">
            <div className="reward-reactor">
              <img src="/images/arcreactor.png" alt="reactor" />
            </div>
            <div className="reward-crystals">
              <img src="/images/crystals.png" alt="crystals" />
            </div>
            <div className="reward-madrid-fren">
              <img src="/images/MadeinMadrid.png" alt="madrid fren" />
            </div>
            <div className="reward-more-tendies">
              <img src="/images/more-tendies.png" alt="more tendies" />
            </div>
            <div className="reward-block">
              <img src="/images/block.png" alt="block" />
            </div>
            <div className="reward-tendies">
              <img src="/images/tendies.png" alt="tendies" />
            </div>
          </div>
          <div className="reward-get-options-text">
            <h3>ARC REACTOR</h3>
            <h3>CRYSTALS</h3>
            <h3>SPECIAL MADE IN MADRID FREN</h3>
            <h3>MORE TENDIES</h3>
            <h3>BLOCK OF LAND AT WADISHADES BAYO</h3>
            <h3>10% TENDIES BURN (EVERY MYSTERY HAS ITS DARK SIDE AS WELL)</h3>
          </div>
        </div>
      </div>
      <div className="reward-frengine">
        <div className="reward-frengine-image">
          <img src="/images/frENGINE1.png" alt="frengine" />
        </div>
        <div className="reward-frengine-description">
          <h2 className="not-mobile">Machine Name : frENGINE</h2>
          <h2 className="reward-frengine-title">frENGINE</h2>
          <h2 className="not-mobile">frENGINE</h2>
          <p>Work : Allows you to produce CyberFrens</p>
          <p>Assets Required to run it :</p>
          <div className="reward-frengine-assets">
            <div className="reward-frengine-crystal">
              <img src="/images/crystals2.png" alt="crystals" />
              <p>Crystals</p>
            </div>
            <div className="reward-frengine-nft mobile">
              <p className="reward-frengine-border not-mobile">FREN NFT</p>
              <h2>NFT </h2>
              <p>
                Any 2 <br /> Fren NFTs
              </p>
            </div>
            <div className="reward-frengine-nft not-mobile">
              <p className="reward-frengine-border not-mobile">FREN NFT</p>
              <p>Any 2 Fren NFTs</p>
            </div>
            <div className="reward-frengine-reactor not-mobile">
              <img src="/images/arcreactor2.png" alt="arcreator" />
              <p>1 Arc Reactor</p>
            </div>
          </div>
          <p className="reward-perks-title">Perks you will get :</p>
        </div>
      </div>
      <div className="reward-perks">
        <div className="rewards-perks-cyberfren">
          <img
            className="not-mobile"
            src="/images/cyberfren2.png"
            alt="cyberfren"
          />
          <img
            className="mobile"
            src="/images/cyberfren3.png"
            alt="cyberfren"
          />
          <h3 className="not-mobile">100%</h3>
        </div>
        <h2 className="mobile">100% CYBER FRENS</h2>
        <h2 className="not-mobile">CYBER FRENS</h2>
        <p>
          A new class of Frens. Blessed with Kek’s glorious GIF powers and given
          life through the Arc Reactor
        </p>
        <div className="reward-vector mobile">
          <img src="/images/Vector.png" alt="vector" />
        </div>
      </div>
    </div>
  );
}
